import React from "react";
import MultiResolutionImage from "./MultiResolutionImage";

const ImageLinkRow = ({ prefix, links }) => {
  return (
    <section className="section is-image-link-row">
      <div className="container">
        <div className="columns is-mobile is-multiline">
          {links.map((link, index) => {
            return (
              <div
                className="column is-6-tablet is-4-desktop is-12-mobile"
                key={`${prefix}-${index}`}
              >
                <div
                  className={`is-image-link-image${
                    link.externalLink ? " has-link" : ""
                  }`}
                >
                  {link.externalLink && (
                    <a href={link.externalLink} target="_blank">
                      <MultiResolutionImage image={link.image} />
                    </a>
                  )}
                  {!link.externalLink && (
                    <MultiResolutionImage image={link.image} />
                  )}
                </div>
                <div
                  className="is-image-link-caption"
                  dangerouslySetInnerHTML={{ __html: link.caption }}
                />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ImageLinkRow;



// WEBPACK FOOTER //
// ./src/components/ImageLinkRow.js